/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountConnectionDto,
  AddressCreateDto,
  AddressVerificationResultDto,
  AdminInviteUpdateDto,
  ApplicationDto,
  ApplicationFileDescriptorDto,
  ApplicationSignUpRequest,
  ApplicationUpdateDto,
  BankAccountResponse,
  BeneficialOwnerCreateDto,
  DunaIdVerificationDto,
  ExternalValidateApplicationParams,
  GetApplicationParams,
  GetExternalInformationRequestsParams,
  IdNowIdVerificationDto,
  IdVerificationDto,
  InformationRequestDto,
  InitiateIdVerificationRequestDto,
  LocationDto,
  LocationWithAddressDto,
  ManagingDirectorUpdateDto,
  OnfidoIdVerificationDto,
  OrganisationDetailsDto,
  OrganisationLoanDto,
  ResetPinDto,
  SearchLocationParams,
  UpdateInformationRequestDto,
  UploadApplicationFileParams,
  UploadApplicationFilePayload,
  UploadInformationRequestDocument1Payload,
  ValidationIssueDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiApplicationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetApplication
   * @request GET:/api/v1/application
   */
  getApplication = (query: GetApplicationParams, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getApplicationPath = '/v1/application'
  static getApplicationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateApplication
   * @request PUT:/api/v1/application
   */
  updateApplication = (data: ApplicationUpdateDto, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateApplicationPath = '/v1/application'
  static updateApplicationMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateOrganisationLoan
   * @request PUT:/api/v1/application/organisation-loans/{organisationLoanId}
   */
  updateOrganisationLoan = (
    organisationLoanId: string,
    data: OrganisationLoanDto,
    params: RequestParams = {},
  ) =>
    this.http.request<OrganisationLoanDto, any>({
      path: `/v1/application/organisation-loans/${organisationLoanId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationLoanPath = '/v1/application/organisation-loans/${organisationLoanId}'
  static updateOrganisationLoanMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteOrganisationLoan
   * @request DELETE:/api/v1/application/organisation-loans/{organisationLoanId}
   */
  deleteOrganisationLoan = (organisationLoanId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/application/organisation-loans/${organisationLoanId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteOrganisationLoanPath = '/v1/application/organisation-loans/${organisationLoanId}'
  static deleteOrganisationLoanMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateOrganisationDetails
   * @request PUT:/api/v1/application/organisation-details
   */
  updateOrganisationDetails = (data: OrganisationDetailsDto, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/organisation-details`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationDetailsPath = '/v1/application/organisation-details'
  static updateOrganisationDetailsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateOrganisationShippingAddress2
   * @request PUT:/api/v1/application/organisation-details/shipping-address
   */
  updateOrganisationShippingAddress = (data: AddressCreateDto, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/organisation-details/shipping-address`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationShippingAddressPath =
    '/v1/application/organisation-details/shipping-address'
  static updateOrganisationShippingAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteOrganisationShippingAddress1
   * @request DELETE:/api/v1/application/organisation-details/shipping-address
   */
  deleteOrganisationShippingAddress = (params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/organisation-details/shipping-address`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteOrganisationShippingAddressPath =
    '/v1/application/organisation-details/shipping-address'
  static deleteOrganisationShippingAddressMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateOrganisationAddress1
   * @request PUT:/api/v1/application/organisation-details/address
   */
  updateOrganisationAddress = (data: AddressCreateDto, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/organisation-details/address`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationAddressPath = '/v1/application/organisation-details/address'
  static updateOrganisationAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateManagingDirector
   * @request PUT:/api/v1/application/managing-directors/{managingDirectorId}
   */
  updateManagingDirector = (
    managingDirectorId: string,
    data: ManagingDirectorUpdateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/managing-directors/${managingDirectorId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateManagingDirectorPath = '/v1/application/managing-directors/${managingDirectorId}'
  static updateManagingDirectorMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteManagingDirector
   * @request DELETE:/api/v1/application/managing-directors/{managingDirectorId}
   */
  deleteManagingDirector = (managingDirectorId: string, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/managing-directors/${managingDirectorId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteManagingDirectorPath = '/v1/application/managing-directors/${managingDirectorId}'
  static deleteManagingDirectorMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateManagingDirectorAddress
   * @request PUT:/api/v1/application/managing-directors/{managingDirectorId}/address
   */
  updateManagingDirectorAddress = (
    managingDirectorId: string,
    data: AddressCreateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/managing-directors/${managingDirectorId}/address`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateManagingDirectorAddressPath =
    '/v1/application/managing-directors/${managingDirectorId}/address'
  static updateManagingDirectorAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateFileDescriptor
   * @request PUT:/api/v1/application/file-descriptors/{descriptorId}
   */
  updateFileDescriptor = (
    descriptorId: string,
    data: ApplicationFileDescriptorDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationFileDescriptorDto, any>({
      path: `/v1/application/file-descriptors/${descriptorId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateFileDescriptorPath = '/v1/application/file-descriptors/${descriptorId}'
  static updateFileDescriptorMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteFileDescriptor
   * @request DELETE:/api/v1/application/file-descriptors/{descriptorId}
   */
  deleteFileDescriptor = (descriptorId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/application/file-descriptors/${descriptorId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteFileDescriptorPath = '/v1/application/file-descriptors/${descriptorId}'
  static deleteFileDescriptorMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateBeneficialOwner
   * @request PUT:/api/v1/application/beneficial-owners/{beneficialOwnerId}
   */
  updateBeneficialOwner = (
    beneficialOwnerId: string,
    data: BeneficialOwnerCreateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/beneficial-owners/${beneficialOwnerId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBeneficialOwnerPath = '/v1/application/beneficial-owners/${beneficialOwnerId}'
  static updateBeneficialOwnerMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteBeneficialOwner
   * @request DELETE:/api/v1/application/beneficial-owners/{beneficialOwnerId}
   */
  deleteBeneficialOwner = (beneficialOwnerId: string, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/beneficial-owners/${beneficialOwnerId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteBeneficialOwnerPath = '/v1/application/beneficial-owners/${beneficialOwnerId}'
  static deleteBeneficialOwnerMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateBeneficialOwnerAddress
   * @request PUT:/api/v1/application/beneficial-owners/{beneficialOwnerId}/address
   */
  updateBeneficialOwnerAddress = (
    beneficialOwnerId: string,
    data: AddressCreateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/beneficial-owners/${beneficialOwnerId}/address`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBeneficialOwnerAddressPath =
    '/v1/application/beneficial-owners/${beneficialOwnerId}/address'
  static updateBeneficialOwnerAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateAdminInvite
   * @request PUT:/api/v1/application/admin-invites/{adminInviteId}
   */
  updateAdminInvite = (
    adminInviteId: string,
    data: AdminInviteUpdateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/admin-invites/${adminInviteId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateAdminInvitePath = '/v1/application/admin-invites/${adminInviteId}'
  static updateAdminInviteMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteAdminInvite
   * @request DELETE:/api/v1/application/admin-invites/{adminInviteId}
   */
  deleteAdminInvite = (adminInviteId: string, params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/admin-invites/${adminInviteId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteAdminInvitePath = '/v1/application/admin-invites/${adminInviteId}'
  static deleteAdminInviteMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name SignUpForApplication
   * @request POST:/api/v1/application/sign-up
   */
  signUpForApplication = (data: ApplicationSignUpRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/application/sign-up`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static signUpForApplicationPath = '/v1/application/sign-up'
  static signUpForApplicationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name CreateResetPinRequest
   * @request POST:/api/v1/application/reset-pin-request
   */
  createResetPinRequest = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/application/reset-pin-request`,
      method: 'POST',
      ...params,
    })

  static createResetPinRequestPath = '/v1/application/reset-pin-request'
  static createResetPinRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name ConfirmResetPinRequest
   * @request POST:/api/v1/application/reset-pin-confirm
   */
  confirmResetPinRequest = (data: ResetPinDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/application/reset-pin-confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static confirmResetPinRequestPath = '/v1/application/reset-pin-confirm'
  static confirmResetPinRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetOrganisationLoans
   * @request GET:/api/v1/application/organisation-loans
   */
  getOrganisationLoans = (params: RequestParams = {}) =>
    this.http.request<OrganisationLoanDto[], any>({
      path: `/v1/application/organisation-loans`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationLoansPath = '/v1/application/organisation-loans'
  static getOrganisationLoansMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name CreateOrganisationLoan
   * @request POST:/api/v1/application/organisation-loans
   */
  createOrganisationLoan = (params: RequestParams = {}) =>
    this.http.request<OrganisationLoanDto, any>({
      path: `/v1/application/organisation-loans`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createOrganisationLoanPath = '/v1/application/organisation-loans'
  static createOrganisationLoanMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name CreateManagingDirector
   * @request POST:/api/v1/application/managing-directors
   */
  createManagingDirector = (params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/managing-directors`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createManagingDirectorPath = '/v1/application/managing-directors'
  static createManagingDirectorMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetVerificationStatus
   * @request GET:/api/v1/application/managing-directors/{managingDirectorId}/verification
   */
  getVerificationStatus = (managingDirectorId: string, params: RequestParams = {}) =>
    this.http.request<
      IdVerificationDto | DunaIdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto,
      any
    >({
      path: `/v1/application/managing-directors/${managingDirectorId}/verification`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVerificationStatusPath =
    '/v1/application/managing-directors/${managingDirectorId}/verification'
  static getVerificationStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name InitiateVerification
   * @request POST:/api/v1/application/managing-directors/{managingDirectorId}/verification
   */
  initiateVerification = (
    managingDirectorId: string,
    data: InitiateIdVerificationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<
      IdVerificationDto | DunaIdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto,
      any
    >({
      path: `/v1/application/managing-directors/${managingDirectorId}/verification`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initiateVerificationPath =
    '/v1/application/managing-directors/${managingDirectorId}/verification'
  static initiateVerificationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name StartVerification
   * @request POST:/api/v1/application/managing-directors/{managingDirectorId}/verification/start
   */
  startVerification = (managingDirectorId: string, params: RequestParams = {}) =>
    this.http.request<
      IdVerificationDto | DunaIdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto,
      any
    >({
      path: `/v1/application/managing-directors/${managingDirectorId}/verification/start`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static startVerificationPath =
    '/v1/application/managing-directors/${managingDirectorId}/verification/start'
  static startVerificationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name RetryVerification
   * @request POST:/api/v1/application/managing-directors/{managingDirectorId}/verification/retry
   */
  retryVerification = (managingDirectorId: string, params: RequestParams = {}) =>
    this.http.request<
      IdVerificationDto | DunaIdVerificationDto | IdNowIdVerificationDto | OnfidoIdVerificationDto,
      any
    >({
      path: `/v1/application/managing-directors/${managingDirectorId}/verification/retry`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static retryVerificationPath =
    '/v1/application/managing-directors/${managingDirectorId}/verification/retry'
  static retryVerificationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name VerifyManagingDirectorAddresses
   * @request POST:/api/v1/application/managing-directors/verify-address
   */
  verifyManagingDirectorAddresses = (params: RequestParams = {}) =>
    this.http.request<AddressVerificationResultDto, any>({
      path: `/v1/application/managing-directors/verify-address`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static verifyManagingDirectorAddressesPath = '/v1/application/managing-directors/verify-address'
  static verifyManagingDirectorAddressesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UploadInformationRequestDocument1
   * @request POST:/api/v1/application/information-requests/{requestId}/document
   */
  uploadInformationRequestDocument = (
    requestId: string,
    data: UploadInformationRequestDocument1Payload,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationRequestDto, any>({
      path: `/v1/application/information-requests/${requestId}/document`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadInformationRequestDocumentPath =
    '/v1/application/information-requests/${requestId}/document'
  static uploadInformationRequestDocumentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteInformationRequestDocument1
   * @request DELETE:/api/v1/application/information-requests/{requestId}/document
   */
  deleteInformationRequestDocument = (requestId: string, params: RequestParams = {}) =>
    this.http.request<InformationRequestDto, any>({
      path: `/v1/application/information-requests/${requestId}/document`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteInformationRequestDocumentPath =
    '/v1/application/information-requests/${requestId}/document'
  static deleteInformationRequestDocumentMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name SubmitInformationRequestResponses1
   * @request POST:/api/v1/application/information-requests/submit
   */
  submitInformationRequestResponses = (params: RequestParams = {}) =>
    this.http.request<InformationRequestDto[], any>({
      path: `/v1/application/information-requests/submit`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static submitInformationRequestResponsesPath = '/v1/application/information-requests/submit'
  static submitInformationRequestResponsesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UploadApplicationFile
   * @request POST:/api/v1/application/file-data
   */
  uploadApplicationFile = (
    query: UploadApplicationFileParams,
    data: UploadApplicationFilePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationFileDescriptorDto, any>({
      path: `/v1/application/file-data`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadApplicationFilePath = '/v1/application/file-data'
  static uploadApplicationFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name CreateBeneficialOwner
   * @request POST:/api/v1/application/beneficial-owners
   */
  createBeneficialOwner = (params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/beneficial-owners`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createBeneficialOwnerPath = '/v1/application/beneficial-owners'
  static createBeneficialOwnerMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name CreateAdminInvite
   * @request POST:/api/v1/application/admin-invites
   */
  createAdminInvite = (params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/admin-invites`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createAdminInvitePath = '/v1/application/admin-invites'
  static createAdminInviteMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name UpdateInformationRequestValue1
   * @request PATCH:/api/v1/application/information-requests/{requestId}
   */
  updateInformationRequestValue = (
    requestId: string,
    data: UpdateInformationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationRequestDto, any>({
      path: `/v1/application/information-requests/${requestId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateInformationRequestValuePath = '/v1/application/information-requests/${requestId}'
  static updateInformationRequestValueMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name ValidateApplication
   * @request GET:/api/v1/application/validate
   */
  validateApplication = (params: RequestParams = {}) =>
    this.http.request<ValidationIssueDto[], any>({
      path: `/v1/application/validate`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static validateApplicationPath = '/v1/application/validate'
  static validateApplicationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetSalesforceModules
   * @request GET:/api/v1/application/salesforce-modules
   */
  getSalesforceModules = (params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/application/salesforce-modules`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSalesforceModulesPath = '/v1/application/salesforce-modules'
  static getSalesforceModulesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name FindLocation
   * @request GET:/api/v1/application/location/{placeId}
   */
  findLocation = (placeId: string, params: RequestParams = {}) =>
    this.http.request<LocationWithAddressDto, any>({
      path: `/v1/application/location/${placeId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findLocationPath = '/v1/application/location/${placeId}'
  static findLocationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name SearchLocation
   * @request GET:/api/v1/application/location/search
   */
  searchLocation = (query: SearchLocationParams, params: RequestParams = {}) =>
    this.http.request<LocationDto[], any>({
      path: `/v1/application/location/search`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static searchLocationPath = '/v1/application/location/search'
  static searchLocationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetLegalForms
   * @request GET:/api/v1/application/legal-forms
   */
  getLegalForms = (params: RequestParams = {}) =>
    this.http.request<
      (
        | 'UNKNOWN'
        | 'GMBH'
        | 'UG'
        | 'AG'
        | 'GMBH_UND_CO_KG'
        | 'PARTG'
        | 'PARTGMBB'
        | 'EV'
        | 'KGAA'
        | 'KG_DE'
        | 'EK'
        | 'EG'
        | 'KDOR'
        | 'OHG'
        | 'EGBR'
        | 'STIFTUNG'
        | 'BV'
        | 'NV'
        | 'CV'
        | 'VERENIGING'
        | 'STICHTING'
        | 'COOPERATIVE_NL'
        | 'VOF'
        | 'EENMANSZAAK'
        | 'MAATSCHAP'
        | 'SL'
        | 'SLNE'
        | 'SA'
        | 'SC'
        | 'SARL'
        | 'SA_FR'
        | 'SAS'
        | 'SCS'
        | 'SNC'
        | 'SCA'
        | 'LTD'
        | 'PLC'
        | 'UNLTD'
        | 'LLP'
        | 'CLG'
        | 'GMBH_AT'
        | 'AG_AT'
        | 'KG'
        | 'OG'
        | 'GEN'
        | 'PRIVATSTIFTUNG'
        | 'FLEXKAPG'
        | 'SRL'
        | 'SPA'
        | 'SAS_IT'
        | 'SNC_IT'
        | 'SAA'
        | 'SC_IT'
        | 'SS'
        | 'AB'
        | 'KB'
        | 'HB'
        | 'BV_BE'
        | 'NV_BE'
        | 'COMMV'
        | 'SC_BE'
        | 'SPZOO'
        | 'SA_PL'
        | 'SPK'
        | 'SPJ'
        | 'SPP'
        | 'SKA'
        | 'LTD_IE'
        | 'DAC'
        | 'PLC_IE'
        | 'CLG_IE'
        | 'SE'
        | 'OTHER'
      )[],
      any
    >({
      path: `/v1/application/legal-forms`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLegalFormsPath = '/v1/application/legal-forms'
  static getLegalFormsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetInformationRequests1
   * @request GET:/api/v1/application/information-requests
   */
  getInformationRequests = (params: RequestParams = {}) =>
    this.http.request<InformationRequestDto[], any>({
      path: `/v1/application/information-requests`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInformationRequestsPath = '/v1/application/information-requests'
  static getInformationRequestsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetFileDescriptors
   * @request GET:/api/v1/application/file-descriptors
   */
  getFileDescriptors = (params: RequestParams = {}) =>
    this.http.request<ApplicationFileDescriptorDto[], any>({
      path: `/v1/application/file-descriptors`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getFileDescriptorsPath = '/v1/application/file-descriptors'
  static getFileDescriptorsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DownloadApplicationFile
   * @request GET:/api/v1/application/file-data/{descriptorId}
   */
  downloadApplicationFile = (descriptorId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/application/file-data/${descriptorId}`,
      method: 'GET',
      ...params,
    })

  static downloadApplicationFilePath = '/v1/application/file-data/${descriptorId}'
  static downloadApplicationFileMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name ExternalValidateApplication
   * @request GET:/api/v1/application/external-validate
   */
  externalValidateApplication = (
    query: ExternalValidateApplicationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ValidationIssueDto[], any>({
      path: `/v1/application/external-validate`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static externalValidateApplicationPath = '/v1/application/external-validate'
  static externalValidateApplicationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetExternalInformationRequests
   * @request GET:/api/v1/application/external-information-requests
   */
  getExternalInformationRequests = (
    query: GetExternalInformationRequestsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationRequestDto[], any>({
      path: `/v1/application/external-information-requests`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getExternalInformationRequestsPath = '/v1/application/external-information-requests'
  static getExternalInformationRequestsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetBankAccounts1
   * @request GET:/api/v1/application/accounts
   */
  getBankAccounts = (params: RequestParams = {}) =>
    this.http.request<BankAccountResponse[], any>({
      path: `/v1/application/accounts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBankAccountsPath = '/v1/application/accounts'
  static getBankAccountsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name GetAccountConnections1
   * @request GET:/api/v1/application/account-connections
   */
  getAccountConnections = (params: RequestParams = {}) =>
    this.http.request<AccountConnectionDto[], any>({
      path: `/v1/application/account-connections`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountConnectionsPath = '/v1/application/account-connections'
  static getAccountConnectionsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller
   * @name DeleteBillingAccount
   * @request DELETE:/api/v1/application/billing-account
   */
  deleteBillingAccount = (params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/application/billing-account`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteBillingAccountPath = '/v1/application/billing-account'
  static deleteBillingAccountMethod = 'DELETE'
}
